import { useMarketIndexes } from '../../store/market/hooks'
import { useMemo } from 'react'
import { BigNumber } from 'ethers'
import { calculateUnrealizedPnL } from './useUnrealizedPnL'
import { bn, e2w } from '../../utils/number'
import { usePerpPositions, usePerpSymbols } from '../../store/perp/hooks'

import { getMarkPriceFromIndexes } from '../../utils/getMarkPriceFromIndexes'
import { PerpPositionRecord } from 'api/v1/perp'
import { MarketIndexes, PerpSymbol } from 'api/v1/market'

export function useRealTimeUnrealizedPnL(): BigNumber {
  const positions = usePerpPositions()
  const indexes = useMarketIndexes()
  const symbols = usePerpSymbols()

  return useMemo(() => {
    return calcRealTimeUnrealizedPnL(positions, indexes, symbols)
  }, [positions, indexes, symbols])
}

export function calcRealTimeUnrealizedPnL(
  positions: PerpPositionRecord[],
  indexes: MarketIndexes,
  symbols: PerpSymbol[],
): BigNumber {
  return positions.reduce((prev, current): BigNumber => {
    const { symbolId = 0, direction, quantity = 0, entryValue = 0 } = current
    const { baseCurrency = '', multiplier = 0 } =
      symbols.find((v) => v.id === symbolId) ?? {}
    const markPrice = getMarkPriceFromIndexes(indexes, baseCurrency)
    const value = calculateUnrealizedPnL(
      direction,
      e2w(markPrice),
      e2w(multiplier),
      e2w(quantity),
      e2w(entryValue),
    )
    return prev.add(value)
  }, bn(0))
}
